import { render, staticRenderFns } from "./EquipamentoAuditoriaTab.vue?vue&type=template&id=a0275820&scoped=true&"
import script from "./EquipamentoAuditoriaTab.vue?vue&type=script&lang=js&"
export * from "./EquipamentoAuditoriaTab.vue?vue&type=script&lang=js&"
import style0 from "./EquipamentoAuditoriaTab.vue?vue&type=style&index=0&id=a0275820&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0275820",
  null
  
)

export default component.exports